const normalizeAccessValue = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const cdlOperatorRoles = ["admin", "technician"];

export const cdlOperator = (user = {}) =>
  normalizeAccessValue(user.organization) === "cdl" &&
  cdlOperatorRoles.includes(normalizeAccessValue(user.role));
